import React, { FunctionComponent, ReactElement, memo } from 'react'
import { ResponsiveType } from '@sport1/react-elements/core/types'
import { SpacingsVariants } from '../../../../DesignSystem/spacings/types'
import BasicButton from '../Basic'
import { ButtonTypes } from '../ButtonTypes'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import LinkProps from '../../../../Link/LinkProps'

export type BigButtonProps = {
    /** text shown inside of the button */
    children: string
    /** href string to navigate to the provided url (web only) */
    href?: string
    /**
     * callback function triggered when button is pressed
     *
     * @TJS-type function
     */
    onPress?: () => void
    /** if expand is provided, the button expands to full width */
    expand?: boolean
    iconName?: 'play_arrow'
    // after padding changes, change these elements just to SystemSpacingProps
    margin?: ResponsiveType<keyof SpacingsVariants>
    marginX?: ResponsiveType<keyof SpacingsVariants>
    marginY?: ResponsiveType<keyof SpacingsVariants>
    marginLeft?: ResponsiveType<keyof SpacingsVariants>
    marginRight?: ResponsiveType<keyof SpacingsVariants>
    marginTop?: ResponsiveType<keyof SpacingsVariants>
    marginBottom?: ResponsiveType<keyof SpacingsVariants>
} & ButtonTypes &
    LinkProps &
    TestID

const BigButton: FunctionComponent<BigButtonProps> = ({
    children,
    backgroundColor = 'pearl',
    href,
    onPress,
    expand,
    iconName,
    testID,
    webRel,
    ...rest
}): ReactElement => {
    return (
        <BasicButton
            height={44}
            paddingX="spacing-7"
            {...{
                href,
                onPress,
                expand,
                backgroundColor,
                iconName,
                testID,
                webRel,
            }}
            {...rest}
        >
            {children}
        </BasicButton>
    )
}

export default memo(BigButton)
